import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2 text-lg font-semibold" }
const _hoisted_2 = { class: "space-y-2 max-h-64 overflow-y-auto" }
const _hoisted_3 = ["for"]

import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';
import { useBuildingStore } from '@/store';

interface OrganizationBuildingInterface {
  id: number;
  organization_id: number;
  name: string;
  location: string | null;
}

type OrganizationBuilding = OrganizationBuildingInterface;

type SelectedOrganizationBuilding = OrganizationBuildingInterface & {
  building_id: number;
};

type EditableOrganizationBuilding = OrganizationBuildingInterface & {
  checked: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BuildingsEdit',
  props: {
    modelValue: { type: Boolean },
    selectedBuildings: {},
    organizationBuildings: {},
    organizationName: {}
  },
  emits: [EMIT.CANCEL, EMIT.ATTACH, EMIT.CLOSE, EMIT.DETACH, EMIT.UPDATE_MODEL_VALUE],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const buildingStore = useBuildingStore();
const props = __props;

const visible = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
  },
);

watch(visible, (val: boolean) => {
  if (!val) {
    emit(EMIT.CANCEL);
    emit(EMIT.UPDATE_MODEL_VALUE, val);
  }
});

const editableBuildings = ref<EditableOrganizationBuilding[]>([]);

const originalSelectedIds = ref<Set<number>>(new Set());

watch(
  [() => props.organizationBuildings, () => props.selectedBuildings],
  ([orgBuildings, selected]) => {
    const selectedIds = new Set(selected.map((b) => b.building_id));
    originalSelectedIds.value = selectedIds;
    editableBuildings.value = orgBuildings.map((b) => ({
      ...b,
      checked: selectedIds.has(b.id),
    }));
  },
  { immediate: true },
);

const close = () => {
  visible.value = false;
};

const save = () => {
  const toAttach: number[] = [];
  const toDetach: number[] = [];

  for (const building of editableBuildings.value) {
    const wasSelected = originalSelectedIds.value.has(building.id);
    const isNowChecked = building.checked;

    if (isNowChecked && !wasSelected) {
      toAttach.push(building.id);
    } else if (!isNowChecked && wasSelected) {
      toDetach.push(building.id);
    }
  }

  if (toAttach.length === 0 && toDetach.length === 0) {
    buildingStore.doToast('No changes made to buildings', '', true);
    visible.value = false;
    return;
  }

  if (toAttach.length > 0) emit(EMIT.ATTACH, toAttach);
  if (toDetach.length > 0) emit(EMIT.DETACH, toDetach);

  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: "Edit Buildings",
    closable: true,
    style: {"width":"500px"},
    draggable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: close
      }),
      _createVNode(_component_AppButton, {
        text: "Save",
        type: "primary",
        onClick: save
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(__props.organizationName || 'Organization'), 1),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-4 text-sm text-gray-600" }, "Select the buildings to assign for this organization:", -1)),
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableBuildings.value, (building) => {
          return (_openBlock(), _createElementBlock("li", {
            key: building.id,
            class: "flex items-center gap-2"
          }, [
            _createVNode(_component_Checkbox, {
              modelValue: building.checked,
              "onUpdate:modelValue": ($event: any) => ((building.checked) = $event),
              "input-id": 'building-' + building.id,
              binary: true
            }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id"]),
            _createElementVNode("label", {
              for: 'building-' + building.id,
              class: "cursor-pointer"
            }, _toDisplayString(building.name), 9, _hoisted_3)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})